import { Component, EventEmitter, Input, Output } from '@angular/core';
import { GridOptions } from 'ag-grid-community';
import { IMeasuresViewModel } from '../../models/interfaces';
import { MatCard, MatCardHeader, MatCardTitle } from '@angular/material/card';
import { DecimalPipe, NgForOf } from '@angular/common';
import { TranslatePipe } from '@ngx-translate/core';
import { MatIcon } from '@angular/material/icon';
import { MatTooltip } from '@angular/material/tooltip';

export interface ICustomMeasureButton {
    tag: any;
    text: string;
    valueToSet: number;
}

@Component({
    selector: 'caliper-measures',
    templateUrl: './caliper-measures.component.html',
    styleUrls: ['./caliper-measures.component.scss'],
    standalone: true,
    imports: [MatCardHeader, MatCard, MatCardTitle, NgForOf, MatIcon, TranslatePipe, DecimalPipe, MatTooltip],
})
export class CaliperMeasuresComponent {
    // Data Members

    @Output()
    measuresRemove = new EventEmitter<IMeasuresViewModel>();
    @Output()
    measuresRemoveAll = new EventEmitter<any>();
    @Output()
    measuresSet = new EventEmitter<ICustomMeasureButton>();
    @Input()
    measuresList!: Array<IMeasuresViewModel>;
    @Input()
    customMeasureButtons!: ICustomMeasureButton[];
    @Input()
    readOnly: boolean = false;

    gridOptions: GridOptions;

    constructor() {
        this.gridOptions = {
            suppressCellFocus: true,
        };
    }

    // Constructor

    get selectedMeasures(): IMeasuresViewModel | null {
        if (!this.measuresList) return null;

        let measures = this.measuresList.filter((item) => item.selected);
        if (!measures || measures.length !== 1) return null;

        return measures[0];
    }

    // public functions

    onRemove(measures: IMeasuresViewModel) {
        this.measuresRemove.emit(measures);
    }

    onMouseOver(measures: IMeasuresViewModel) {
        measures.caliper.highlight = true;
    }

    onMouseOut(measures: IMeasuresViewModel) {
        measures.caliper.highlight = false;
    }

    onRemoveAll() {
        this.measuresRemoveAll.emit();
    }

    onSelect(measures: IMeasuresViewModel) {
        this.measuresList.forEach((measures) => (measures.selected = false));
        measures.selected = true;
    }

    onClick(customMeasureButton: ICustomMeasureButton) {
        this.measuresSet.emit(customMeasureButton);
    }
}
